import type {ExplorePageVariant} from './types';

export function getSubtitle(variant: ExplorePageVariant): string {
    if (variant === 'trial') {
        return 'Learn the essentials, knock out quick wins, and watch your CRM come to life — one simple checklist at a time.';
    } else {
        return 'Explore updates, features, and upcoming events - all in one place.';
    }
}

export function getWelcomeMessage(
    variant: ExplorePageVariant,
    userFirstName: string | null | undefined
): string {
    if (variant === 'trial') {
        return userFirstName ? `Welcome to Nutshell, ${userFirstName}!` : 'Welcome to Nutshell!';
    } else {
        const relativeGreeting = getRelativeGreeting();

        return userFirstName
            ? `Good ${relativeGreeting}, ${userFirstName}!`
            : `Good ${relativeGreeting}!`;
    }
}

/*
This function returns the relative greeting based on the current hour.
The hours are based on the Nutshell business hours.
3am - 12pm: morning
12pm - 6pm: afternoon
6pm - 3am: evening
*/
function getRelativeGreeting(): 'morning' | 'afternoon' | 'evening' {
    const hour = new Date().getHours();

    if (hour >= 3 && hour < 12) {
        return 'morning';
    } else if (hour < 3 || hour >= 18) {
        return 'evening';
    } else {
        return 'afternoon';
    }
}
